import type { VenueAuditEntry } from '../../../../api/venues';

const monthDay = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit' });

type Change = { before: unknown; after: unknown };

function changeTo(entry: VenueAuditEntry, field: string): Change | null {
  const changes = entry.fieldChanges;
  if (typeof changes !== 'object' || changes === null || Array.isArray(changes)) return null;
  return field in changes ? ((changes as Record<string, Change>)[field] ?? null) : null;
}

/**
 * "Name · Oct 08" for the latest audit entry that changed `field`, or null when there is none.
 * The audit log is newest first. `keep` narrows which changes count.
 */
export function lastEditedBy(
  audit: VenueAuditEntry[] | undefined,
  field: string,
  keep: (change: Change) => boolean = () => true,
): string | null {
  const entry = (audit ?? []).find((e) => {
    const change = changeTo(e, field);
    return change !== null && keep(change);
  });
  if (!entry?.actorEmail) return null;
  const when = new Date(entry.changedAt);
  if (Number.isNaN(when.getTime())) return null;
  return `${entry.actorEmail} · ${monthDay.format(when)}`;
}

/** Who last uploaded the staff photo; a removal does not count. */
export const photoUploadedBy = (audit: VenueAuditEntry[] | undefined) =>
  lastEditedBy(
    audit,
    'heroImagePath',
    (change) => change.after !== null && change.after !== undefined,
  );

export const descriptionEditedBy = (audit: VenueAuditEntry[] | undefined) =>
  lastEditedBy(audit, 'description');
